import { Svg } from "@/types";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, IconButton } from "@mui/material";
import Popover from "@mui/material/Popover";
import * as React from "react";

export default function CustomIconPopover({
  icon: Icon,
  iconSize = "medium",
  iconColor,
  children,
  triggerType = "click",
}: CustomIconPopoverProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (triggerType === "click") {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleHoverEnter = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (triggerType === "hover") {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleHoverLeave = () => {
    if (triggerType === "hover") {
      setAnchorEl(null);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open
    ? triggerType === "click"
      ? "simple-popover"
      : "mouse-over-popover"
    : undefined;

  return (
    <Box>
      <IconButton
        aria-owns={id}
        aria-haspopup={triggerType === "hover" ? "true" : undefined}
        onClick={handleClick}
        onMouseEnter={handleHoverEnter}
        onMouseLeave={handleHoverLeave}
      >
        {Icon ? (
          <Icon fontSize={iconSize} color={iconColor ?? "inherit"} />
        ) : (
          <InfoOutlinedIcon fontSize={iconSize} />
        )}
      </IconButton>
      <Popover
        id={id}
        sx={{ pointerEvents: triggerType === "hover" ? "none" : "auto" }}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            padding: 1,
            gap: 2,
            maxWidth: 470,
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              padding: 1,
              gap: 2,
            }}
          >
            {children}
          </Box>
        </Box>
      </Popover>
    </Box>
  );
}

export interface CustomIconPopoverProps {
  icon?: Svg | null;
  iconSize?: "medium" | "small";
  iconColor?: "info" | "success" | "warning" | "error";
  children: React.ReactNode;
  triggerType?: "click" | "hover";
}
